import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/checkout';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  /** 'checkout' opens the payment page, 'offer' scrolls to the offer section. */
  target?: 'checkout' | 'offer';
}
export function CtaButton({
  children,
  size = 'md',
  fullWidth = false,
  target = 'checkout'
}: CtaButtonProps) {
  const isCheckout = target === 'checkout';
  const handleClick = () => {
    trackPixelEvent(isCheckout ? 'InitiateCheckout' : 'ViewContent', {
      content_name: "Jazz Teacher's Arsenal — Complete Package",
      value: 27,
      currency: 'USD'
    });
  };
  return <a href={isCheckout ? CHECKOUT_URL : '#offer'} {...isCheckout ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-lg bg-amber text-center font-bold uppercase leading-tight tracking-[0.08em] text-night transition-[background-color,transform] duration-150 ease-out hover:bg-amber-light active:translate-y-px ${size === 'lg' ? 'px-6 py-4 text-sm sm:px-9 sm:py-5 sm:text-base' : 'px-5 py-3 text-xs sm:px-7 sm:py-4 sm:text-sm'} ${fullWidth ? 'w-full' : ''}`} data-id="element-85" data-mp="vdd9xcw9ab9k">
      {children}
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-86" data-mp="3owtlnyta4y5j" />
    </a>;
}